export default __webpack_public_path__ + "static/media/banner2_1500x500.250d82a4.jpg";